module.exports = __webpack_public_path__ + "24b31b623bbca642a20d05dbb37bf43b.MP3";